import {useParams, useLocation, useNavigate} from 'react-router'

import {HierarchyRouteSegment} from '../routing'

type Params = {
  plantId?: string
}

export const useReplacePlantId = () => {
  const {plantId: currentPlantId} = useParams<Params>()

  const location = useLocation()
  const navigate = useNavigate()

  return (newPlantId: string) => {
    if (!currentPlantId) {
      throw new Error('plantId is missing in the URL parameters')
    }
    const newPath = location.pathname.replace(
      `/${HierarchyRouteSegment.PLANT}/${currentPlantId}`,
      `/${HierarchyRouteSegment.PLANT}/${newPlantId}`
    )
    // Persist query params
    void navigate(`${newPath}${location.search}`)
  }
}
